import type { InterventionProps } from "../../types";
import { usePreload } from "../../hooks";
import { TradeBasedPopup, homebuilder } from "../../components/TradeBased";

export const getMainText = (amount: string) => {
  return `Over the last 2 years, the average claim was ${amount} for someone in your trade. 93% of settled claims get processed in less than 48 hours.*`;
};

export const getFinePrint = (trade: string, amount: string) => {
  return `*The average claim value for ${trade} between 1st January 2024 and 31st December 2025 was ${amount}. We define settled claims as a claim that has been agreed by all parties that a payment can be made. It can take longer from a claim being raised to it being settled and paid.`;
};

const isReactControl = (componentNames: string[]): boolean => {
  return componentNames.includes("popup-control");
};

export const TradeBasedAverageClaims = (props: InterventionProps) => {
  usePreload(homebuilder);
  const { data } = props;

  // Legacy: data is undefined, this becomes undefined
  // Q2Q: data is defined and if component_names isn't included for some reason, this becomes undefined
  const isReactControlVariant =
    data?.component_names && isReactControl(data.component_names);

  if (isReactControlVariant)
    return <div data-testid="popup-control-intervention"></div>;

  if (
    !data?.context_data ||
    !data?.context_data?.ClaimsText ||
    !data?.context_data?.PluralizedFriendlyTradeName
  )
    return null;

  const claimsAmount = data.context_data.ClaimsText as string;
  const tradeName = data.context_data.PluralizedFriendlyTradeName as string;

  return (
    <TradeBasedPopup
      {...props}
      mainText={getMainText(claimsAmount)}
      finePrint={getFinePrint(tradeName, claimsAmount)}
    />
  );
};
